
export enum Gender {
    None,
    Female,
    Male
}
export const Tenant = {
    OM: { 'id': 1, 'Code': 'OM' },
    AE: { 'id': 2, 'Code': 'AE' },
    JO: { 'id': 3, 'Code': 'JO' },
    EG: { 'id': 4, 'Code': 'EG' },
    DN: { 'id': 5, 'Code': 'DN' },
    KSA: { 'id': 6, 'Code': 'SA' },
    QA: { 'id': 7, 'Code': 'QA' },
    BH: { 'id': 8, 'Code': 'BH' },
    KW: { 'id': 9, 'Code': 'KW' },
    PK: { 'id': 10, 'Code': 'PK' },
    LB: { 'id': 11, 'Code': 'LB' },
};

export const IndividualTenantArr = [2,11];
export const IndividualProductArr = [ 11 , 14];

export enum ClaimType {
    NoClaim = 0,
    MonthWise = 1,
    PaidOS = 2,
    Consolidated = 3
}
export enum AppService {
    Health = 1,
    Life = 2
}
export enum PolicyType {
    Group = 1,
    Individual = 2
}
